import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";
import demo from "../assets/demo.svg";
import blueglow from "../assets/blueglow.png";
import { Player } from "@lottiefiles/react-lottie-player";
import { homeLottieJson } from "../utils/constants.js";
import "./HomePage.css";

const HomePage = () => {
  return (
    <div className="home-page">
      {/*<img src={blueglow} alt="pill" className="blueglow" />*/}
      <div className="home-nav">
        <NavLink to="/" style={{ textDecoration: "none" }}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <img src={logo} alt="logo" className="logo" />
          </span>
        </NavLink>
        <NavLink to="/login" className="login-button">
          <button className="demo-button">
            <p>Demo</p>
          </button>
        </NavLink>
      </div>

      <div className="home-main">
        <div className="content">
          <h1>Re-imagine Telemedicine</h1>
          <p className="content-main">
            Over the past decade, telemedicine has undergone a remarkable
            transformation, enabling healthcare providers to assess, diagnose,
            and provide remote treatment to patients using telecommunications
            technology.
          </p>
          <div className="buttons">
            <NavLink to="/login">
              <button className="view" type="button">
                Login as Patient
              </button>
            </NavLink>
            <NavLink to="/login">
              <button className="begin" type="button">
                Login as a Helper
              </button>
            </NavLink>
            <NavLink to="/logindoctor">
              <button className="begin" type="button">
                Login as a Doctor
              </button>
            </NavLink>
          </div>
        </div>
        <div>
          <Player src={homeLottieJson} className="righthome" autoplay loop />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
